import React, { useState,   useEffect  } from 'react';
import { useFormik } from 'formik';
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import useHeaders from '../../helpers/useHeaders';
import useToast from '../../helpers/useToast';
import { toast } from "react-toastify";
import useEncryption from '../../services/useEncryption';
import "../doctor/components/allpages.css";
import { changeProviderApi, getAllActiveProviderApi } from '../../api/adminApi/adminApi';
import { createAuditLogs } from '../../api/providerApi/providerApi';

const ChangeProviderModal = ({ changeProvider, handleClose, lead, setUpdate, type }) => {
    const [providers, setProviders] = useState([])
    const headers = useHeaders();
    const toastOptions = useToast();
    const { encryptData, decryptData  } = useEncryption();
    useEffect(() => {
        if(changeProvider) {
            fetchData();
        }        
    }, [changeProvider]);

    const fetchData = async () => {

        try {
            const response = await getAllActiveProviderApi( headers )
            const decryptedData = decryptData(response?.data?.data);
            setProviders(decryptedData);
            formik.setValues({
                providerId: lead.providerId || '', 
            });
          
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    const formik = useFormik({
        initialValues: {
            providerId: '',  
        },
        onSubmit: async (values) => {
        try {
            values.type = type;
            const data = encryptData(values);
            const response = await changeProviderApi(lead._id, data, headers); 
            let obj = {
                event : `SuperAdmin has updated the provider for the ${type}.`
            }
            await createAuditLogs({ data: encryptData(obj)}, headers);
            toast.success(response.data.message,toastOptions);
            setUpdate(prev => !prev);
            handleCancel();
        } catch (error) {
            toast.error(error.response.data.message, toastOptions);
        }
        },
    });

    const handleCancel = () => {
        formik.resetForm();
        handleClose();
    };

    return (
        <Dialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={changeProvider}
        >
            <div className="d-flex align-items-center justify-content-between">
                <DialogTitle id="customized-dialog-title">
                    Change Provider
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleCancel}
                >
                    <CloseIcon />
                </IconButton>
            </div>

            <DialogContent dividers>
                <form className='sectionalForms' onSubmit={formik.handleSubmit}>
                    <div className="row">
                        <div className="col-lg-12 col-sm-12">
                            <div className="formdesign">
                            <FormControl fullWidth variant="outlined" size="small">
                                    <InputLabel id="provider-label">Select Provider</InputLabel>
                                    <Select
                                        labelId="provider-label"
                                        id="providerId"
                                        name="providerId"
                                        value={formik.values.providerId}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.providerId && Boolean(formik.errors.providerId)}
                                        label="Select Provider"
                                    >
                                        {providers.map((provider) => (
                                            <MenuItem key={provider.id} value={provider.id}>
                                                {provider.organizationName}
                                            </MenuItem>
                                        ))}
                                    </Select>

                                    {formik.touched.providerId && formik.errors.providerId && (
                                        <div className="error">{formik.errors.providerId}</div>
                                    )}
                                </FormControl>
                            </div>
                        </div>
                    </div>
                </form>
            </DialogContent>

            <DialogActions>
                <div className="text-end modalactions">
                    <button className='btn btn-blacked outline me-2' onClick={handleCancel}>
                        Cancel
                    </button>
                    <button className='btn btn-blacked' onClick={formik.handleSubmit}>
                        Submit
                    </button>
                </div>
            </DialogActions>
        </Dialog>
    );
};

export default ChangeProviderModal;
